import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$assign from "@babel/runtime-corejs3/core-js/object/assign";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Number$isNaN from "@babel/runtime-corejs3/core-js/number/is-nan";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { reactive, computed, defineComponent, ref, onMounted, onUnmounted, watch } from "@vue/composition-api";
import * as FieldComponents from "@Shared/components/sections/index";
import { formatMoneyValueLong } from "@Shared/@Utils/helpers/money";
import SectionError from "@Shared/components/sections/section-error.vue";
import ReportTabLayout from "@Broker/@Modules/clients/reports/reports-containers/report-tab-layout.vue";
import MortgageCalculatorsToolbar from "./mortgage-calculators-toolbar.vue";
import i18n from "@Shared/i18n";
import { showToast } from "@Shared/@Utils/constants";
import * as FinancialToolsActions from "../store/financial-tools-actions";
import { createNamespacedHelpers } from "vuex-composition-helpers";
const {
  useActions: useFinancialToolsActions
} = createNamespacedHelpers("FinancialToolsStore");
export const componentName = "MaximumMortgageContainer";
export default defineComponent({
  name: componentName,
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    SectionError,
    MortgageCalculatorsToolbar,
    ReportTabLayout
  }),
  props: {
    initData: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const indata = reactive({
      income: 0,
      interestOnly: false,
      propertytax: 0,
      interestRate: 0,
      heatingcost: 0,
      condofee: 0,
      condoFeesPercentage: 0,
      downpayment: 0,
      amortizPeriodMths: 0,
      monthlyDebts: 0,
      gds: 0,
      tds: 0,
      preparedFor: ""
    });
    const outdata = ref({
      maximumMortgage: -1,
      PandI: -1
    });
    function resetResults() {
      outdata.value.maximumMortgage = -1;
      outdata.value.PandI = -1;
    }
    let initialAmortizPeriodMths = 300;
    const isEmbedded = computed(() => props.initData.mortgageType);
    const populateFromApplication = () => {
      const theInitData = props.initData;
      const mortgageType = theInitData.mortgageType;
      if (!mortgageType) return false;
      indata.income = Number(Number(theInitData.income || 0).toFixed(2));
      indata.propertytax = theInitData.propertytax;
      indata.heatingcost = theInitData.heatingcost;
      indata.condofee = theInitData.condofee;
      indata.condoFeesPercentage = theInitData.condoFeesPercentage;
      indata.downpayment = theInitData.downpayment;
      indata.interestRate = theInitData.interestRate;
      indata.amortizPeriodMths = theInitData.amortizPeriodMths;
      initialAmortizPeriodMths = theInitData.amortizPeriodMths;
      indata.monthlyDebts = theInitData.monthlyDebts;
      indata.interestOnly = theInitData.interestOnly;
      indata.preparedFor = theInitData.prepared_for;
      resetResults();
      return true;
    };
    const errorRate = theRate => {
      return theRate < 0.001 || theRate > 100.0 ? i18n.t("financial-tools.message_missing_question_2").toString() : "";
    };
    const errorMessageIncome = computed(() => {
      return indata.income < 10000 || indata.income > 100000000 ? i18n.t("financial-tools.message_missing_question_1").toString() : "";
    });
    const errorMessageRate = computed(() => {
      return errorRate(indata.interestRate);
    });
    const errorMessageIncCondo = computed(() => {
      return indata.condoFeesPercentage === 0 ? "" : errorRate(indata.condoFeesPercentage);
    });
    const errorMessageGDS = computed(() => {
      return errorRate(indata.gds);
    });
    const errorMessageTDS = computed(() => {
      return errorRate(indata.tds);
    });
    const errorMessagePropertytax = computed(() => {
      return indata.propertytax < 0 || indata.propertytax >= 100000 ? i18n.t("financial-tools.message_missing_question100k").toString() : "";
    });
    const errorMessageHeatingcost = computed(() => {
      return indata.heatingcost < 0 || indata.heatingcost >= 100000 ? i18n.t("financial-tools.message_missing_question100k").toString() : "";
    });
    const errorMessageDownpayment = computed(() => {
      return indata.downpayment < 0 || indata.downpayment >= 100000000 ? i18n.t("financial-tools.message_missing_question100M").toString() : "";
    });
    const errorMessageCondofee = computed(() => {
      return indata.condofee < 0 || indata.condofee >= 100000 ? i18n.t("financial-tools.message_missing_question100k").toString() : "";
    });
    const errorMessageAmortizPeriod = computed(() => {
      if (indata.interestOnly) return "";
      const amorty = indata.amortizPeriodMths;
      return amorty < 1 * 12 || amorty > 35 * 12 ? i18n.t("financial-tools.message_missing_question_3").toString() : "";
    });
    const errorMessageMonthlyDebts = computed(() => {
      return indata.monthlyDebts < 0 || indata.monthlyDebts >= 100000 ? i18n.t("financial-tools.message_missing_question100k").toString() : "";
    });
    const erMsgs = {
      errorMessageIncome,
      errorMessageRate,
      errorMessagePropertytax,
      errorMessageHeatingcost,
      errorMessageDownpayment,
      errorMessageCondofee,
      errorMessageAmortizPeriod,
      errorMessageMonthlyDebts,
      errorMessageIncCondo,
      errorMessageGDS,
      errorMessageTDS
    };
    watch(() => indata.interestOnly, isInterestOnly => {
      if (isInterestOnly) {
        indata.amortizPeriodMths = 0;
      } else {
        indata.amortizPeriodMths = initialAmortizPeriodMths;
      }
    });
    const validateInputs = () => {
      const fields = [{
        label: i18n.t("financial-tools.income").toString(),
        error: errorMessageIncome.value
      }, {
        label: i18n.t("financial-tools.property_taxes").toString(),
        error: errorMessagePropertytax.value
      }, {
        label: i18n.t("financial-tools.interest_rate").toString(),
        error: errorMessageRate.value
      }, {
        label: i18n.t("financial-tools.heating_cost").toString(),
        error: errorMessageHeatingcost.value
      }, {
        label: i18n.t("financial-tools.monthly_debts").toString(),
        error: errorMessageMonthlyDebts.value
      }, {
        label: i18n.t("financial-tools.condo_fees").toString(),
        error: errorMessageCondofee.value
      }, {
        label: i18n.t("application-form.amortization").toString(),
        error: errorMessageAmortizPeriod.value
      }, {
        label: i18n.t("financial-tools.condoFeesPercentage").toString(),
        error: errorMessageIncCondo.value
      }, {
        label: i18n.t("application.calculations.gds").toString(),
        error: errorMessageGDS.value
      }, {
        label: i18n.t("application.calculations.tds").toString(),
        error: errorMessageTDS.value
      }];
      let valid = true;
      fields.forEach(({
        label,
        error
      }) => {
        if (error !== "") {
          showToast("error", label + ": " + error);
          valid = false;
        }
      });
      return valid;
    };
    const formatMoney = val => {
      return val && val > 0 ? formatMoneyValueLong(val) : "-";
    };
    const handleClearSelection = () => {
      indata.income = 0;
      indata.propertytax = 0;
      indata.interestRate = 0.001;
      indata.heatingcost = 0;
      indata.downpayment = 0;
      indata.condofee = 0;
      indata.condoFeesPercentage = 50;
      indata.amortizPeriodMths = 300;
      indata.monthlyDebts = 0;
      indata.interestOnly = false;
      indata.gds = 32;
      indata.tds = 40;
      indata.preparedFor = "";
      resetResults();
    };
    handleClearSelection();
    if (!populateFromApplication()) {
      const thisComponentCookieString = localStorage.getItem(componentName);
      if (thisComponentCookieString) {
        try {
          const thisComponentCookieData = JSON.parse(thisComponentCookieString);
          _Object$assign(indata, thisComponentCookieData);
        } catch (e) {
          console.error("Error parsing localStorage data for " + componentName + ":", e);
          localStorage.removeItem(componentName);
        }
      }
    }
    const handleCalc = () => {
      if (!validateInputs()) {
        resetResults();
        return false;
      }
      let inputs = _objectSpread({}, indata);
      const inputKeys = _Object$keys(indata);
      inputKeys.forEach(function (key) {
        const v = indata[key];
        if (!_Number$isNaN(v)) inputs[key] = Number(v);
      });
      const monTime = inputs.amortizPeriodMths;
      const base = 1 + inputs.interestRate / (100 * 2);
      const expo = 2.0 / 12.0;
      const intFactor = Math.pow(base, expo) - 1;
      const tempFactor = 1 - 1 / Math.pow(intFactor + 1, monTime);
      const compound = 2.0 / 12.0;
      const yrRate = inputs.interestRate / 100 / 2;
      const rdefine = Math.pow(1.0 + yrRate, compound) - 1.0;
      const purchcompound = Math.pow(1.0 + rdefine, monTime);
      const maxgdsr = inputs.gds / 100;
      const maxtdsr = inputs.tds / 100;
      const condoFees = inputs.condofee * inputs.condoFeesPercentage / 100;
      const exp = inputs.propertytax + (inputs.heatingcost + condoFees) * 12;
      const GDSPAY = maxgdsr * inputs.income - exp;
      const TDSPAY = maxtdsr * inputs.income - exp - inputs.monthlyDebts * 12;
      let PAYMENT = Math.min(GDSPAY, TDSPAY) / 12.0;
      let monthlypi;
      let MORTGAGE;
      if (inputs.interestOnly) {
        MORTGAGE = PAYMENT / intFactor;
        MORTGAGE = Math.round(MORTGAGE * 100) / 100;
        monthlypi = intFactor * MORTGAGE;
        monthlypi = Math.round(monthlypi * 100) / 100;
      } else {
        MORTGAGE = PAYMENT * (purchcompound - 1.0) / rdefine / purchcompound;
        MORTGAGE = Math.round(MORTGAGE * 100) / 100;
        monthlypi = MORTGAGE * intFactor / tempFactor;
      }
      outdata.value.PandI = monthlypi;
      outdata.value.maximumMortgage = MORTGAGE;
      return true;
    };
    onMounted(() => {
      $("[name='income']").trigger("focus");
    });
    onUnmounted(() => {
      if (!isEmbedded.value) localStorage.setItem(componentName, _JSON$stringify(indata));
    });
    const {
      PRINT_MAXIMUM_MORTGAGE_FORM
    } = useFinancialToolsActions([FinancialToolsActions.PRINT_MAXIMUM_MORTGAGE_FORM]);
    const isLoading = ref(false);
    const runReport = async () => {
      if (!handleCalc()) return;
      isLoading.value = true;
      const data = _objectSpread(_objectSpread({}, indata), {}, {
        principalInterest: outdata.value.PandI,
        maximumMortgage: outdata.value.maximumMortgage,
        householdIncome: indata.income,
        propertyTaxes: indata.propertytax,
        heating: indata.heatingcost,
        condoFees: indata.condofee,
        debts: indata.monthlyDebts,
        amortization: indata.amortizPeriodMths,
        GDS: indata.gds,
        TDS: indata.tds
      });
      try {
        await PRINT_MAXIMUM_MORTGAGE_FORM({
          data
        });
      } catch (e) {
        console.error(e);
      }
      isLoading.value = false;
    };
    return {
      indata,
      outdata,
      erMsgs,
      isLoading,
      isEmbedded,
      formatMoney,
      handleClearSelection,
      handleCalc,
      runReport
    };
  }
});